import { FC } from 'react';

import { WarningAltFilled } from '@mint-lib/icons';
import { RichTooltipAggrid } from '@mint-lib/tw-components';

type Props = {
  children: React.ReactNode;
};

export const ErrorTooltip: FC<Props> = ({ children }) => {
  return (
    <RichTooltipAggrid type="error">
      <WarningAltFilled className="min-w-4" /> {children}
    </RichTooltipAggrid>
  );
};
